export function useAnalytics() {
  function pushAnalyticsEvent(event: any) {
    window.dataLayer.push(event);
  }

  function addCustomGaEvent(event: any) {
    window.dataLayer.push(event);
  }

  return { pushAnalyticsEvent, addCustomGaEvent };
}
